/* LandedSEA prepaid-duties widget (was inline in snippets/landedsea-ddp.liquid) - moved out of the page HTML on 2 Nov 2026 (ix-speed S, conversion/pagespeed/cart-js-to-assets.mjs) so the page downloads faster.
   THIS FILE IS NOW THE ONLY COPY OF THIS CODE - edit it here, not in the snippet. Cart routes / country come from the inline config the snippet prints. */
(function(){
  "use strict";
  if(window.__lsddp) return; window.__lsddp=1;   // bind once (survives section swaps)
  // Two copies of this widget exist on /cart: the cart footer's, and the drawer's. The drawer's sits
  // straight under <body>, outside any Shopify section, and it comes FIRST in the DOM - so
  // getElementById handed back a copy no section swap ever refreshes. Prefer the section copy.
  function box(){
    var all=document.querySelectorAll('#landedsea-ddp');
    for(var i=0;i<all.length;i++){ if(all[i].closest('[id^="shopify-section"]')) return all[i]; }
    return all[0]||null;
  }
  // ---- MutationObserver pause guard ----
  // The observer below watches the cart for THEME-driven changes (qty steppers, item removal).
  // But our own decorate()/swap()/optimisticLine() also mutate that same subtree — which re-fired
  // the observer → endless resync (footer re-rendered on a loop; the pop "blink"), and during a
  // toggle a background resync raced the cart mutation into a Shopify 422 lock → catch → full
  // location.reload() (the "severe lag"). Fix: run our own DOM writes with the observer detached
  // so only REAL theme changes trigger a resync.
  var lsObs=null, lsTarget=null, LSOBS={childList:true,subtree:true};
  function lsObsOn(){ if(lsObs&&lsTarget) lsObs.observe(lsTarget,LSOBS); }
  function lsObsOff(){ if(lsObs) lsObs.disconnect(); }
  function lsQuiet(fn){ lsObsOff(); try{ return fn(); } finally { lsObsOn(); } }
  function data(){ var b=box(); if(!b) return {v:[],addon:0}; var v=[];
    try{ v=JSON.parse(b.getAttribute('data-variants')||'[]'); }catch(e){}
    return { v:v, addon:parseFloat(b.getAttribute('data-addon'))||0, ids:(function(){var m={};v.forEach(function(x){m[x[0]]=1;});return m;})() }; }
  var DRAWER='cart-drawer';
  function withDrawer(secs){ var a=(secs?secs.split(','):[]); if(a.indexOf(DRAWER)<0) a.push(DRAWER); return a.join(','); }
  /* 2026-09-26 (Adam: "when i toggle on to off, the drawer cart closes and the page is refreshed"): in the cart DRAWER the
     widget sits outside any shopify-section, so sectionIds() is empty, getSections('') returned null and toggle() fell into
     location.reload(). In the drawer, re-render through the theme's own cart-drawer.renderContents() (it stays open). */
  var DRAWER_SECS='cart-drawer,cart-icon-bubble';
  function inDrawer(){ var b=box(); return !!(b && b.closest && b.closest('cart-drawer, #CartDrawer')); }
  function drawerOk(r){ return !!(r && r.sections && typeof r.sections['cart-drawer']==='string' && typeof r.sections['cart-icon-bubble']==='string'); }
  async function refreshDrawer(resp){
    var el=document.querySelector('cart-drawer'); if(!el || typeof el.renderContents!=='function') return false;
    var r=drawerOk(resp) ? resp : await getSections(DRAWER_SECS);
    if(!drawerOk(r)) return false;
    lsQuiet(function(){ el.renderContents({ id: null, sections: r.sections }); });
    decorate(); return true;
  }
  function absorb(html){
    if(!html) return;
    var src=new DOMParser().parseFromString(html,'text/html').getElementById('landedsea-ddp');
    if(!src) return;
    var keys=['data-addon','data-below','data-amt','data-total','data-variants'];
    // Crossing the de-minimis line (NZ$1,000 / A$1,000 / ...) swaps the WHOLE card between the green
    // "No import duties or taxes" panel and the prepay toggle. Copying data-* only left the old card text on
    // screen: a NZ$1,232 cart still read "Your order is under NZ$1,000" (Adam 2026-09-23, spotted next to the
    // drawer estimate saying "Payable on delivery"). When that flag flips, take the server's markup too.
    var flip = src.getAttribute('data-below');
    lsQuiet(function(){ document.querySelectorAll('#landedsea-ddp').forEach(function(b){
      if(flip!=null && b.getAttribute('data-below')!==flip) b.innerHTML = src.innerHTML;
      keys.forEach(function(k){ var v=src.getAttribute(k); if(v!=null) b.setAttribute(k,v); });
    }); });
  }
  var LSU={add:window.LSR.add+'.js',change:window.LSR.change+'.js',update:window.LSR.update+'.js',cart:window.LSR.cart}; function post(u,b){ return fetch(u,{method:'POST',headers:{'Content-Type':'application/json','X-LandedSEA':'1'},body:JSON.stringify(b)}).then(function(r){return r.json();}); }
  function getCart(){ return fetch(LSU.cart+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); }
  // Section refresh WITHOUT a cart write: the Section Rendering API (GET) returns the same HTML as
  // POST /cart/update.js{sections} but runs ~0.3s instead of ~0.9s, and never takes the cart lock.
  // (2026-09-20: two of these fired on every add-to-cart, adding ~2s before the drawer settled.)
  function getSections(secs){
    if(!secs) return Promise.resolve(null);
    var want=secs.split(',');
    function fallback(){ return post(LSU.update,{sections:secs,sections_url:LSU.cart}); }
    // NO 'Accept: application/json' header. With it Shopify IGNORES ?sections= and returns the CART object,
    // so {sections:j} held cart fields, every swap()/absorb() was a silent no-op and the widget never
    // refreshed: data-below stayed stale and an orphaned prepaid-duties line survived removing the last
    // product (Adam 2026-09-23, AU cart A$123.42). Verified live: without the header the same URL returns
    // the section HTML. Keys are checked so a shape change falls back to the POST API instead of no-opping.
    return fetch(LSU.cart+'?sections='+encodeURIComponent(secs))
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){
        if(!j || typeof j!=='object') return fallback();
        for(var i=0;i<want.length;i++){ if(typeof j[want[i]]!=='string') return fallback(); }
        return {sections:j};
      })
      .catch(fallback);
  }
  function nearest(v,t){ var best=v[0],bd=Infinity; v.forEach(function(x){var d=Math.abs(x[1]-t);if(d<bd){bd=d;best=x;}}); return best; }
  // The helper ladder stops at S$500. A cart needing more than that used to take the top rung and
  // silently swallow the difference, so buy the rung N times instead.
  function plan(v,t){
    if(!v||!v.length) return null;
    var top=0; v.forEach(function(x){ if(x[1]>top) top=x[1]; });
    var qty=(top>0&&t>top)?Math.ceil(t/top):1;
    return { v:nearest(v, t/qty), qty:qty };
  }
  // A duty line also goes stale when the COUNTRY changes, not only when the amount does. The country is
  // baked into the line property at add time (see the /cart/add.js calls below), so a shopper who adds the
  // duty while Shopify has them in one market and then checks out to another keeps the OLD country - and
  // because samePlan used to compare only variant+quantity, it passed silently whenever the two countries
  // happened to need the same rung. Seen live: abandoned checkout 37124796973102, shipping to Sokoto NIGERIA
  // in NGN, carrying 'Import duties & taxes = France (DDP)' on the S$140 rung (the recovery URL still reads
  // locale=en-FR). Same under-collection class as the FedEx duty audit, where #29351 collected S$43.35 on a
  // cart FedEx then billed S$115.91 for.
  // Only flags when BOTH sides are known: a line with no country property predates it, and removing those
  // would nag customers over something we cannot actually verify.
  function sameCountry(line){
    var want=((box()&&box().getAttribute('data-country'))||'').trim();
    var got=(((line&&line.properties&&line.properties['Import duties & taxes'])||'')+'').replace(/\s*\(DDP\)\s*$/,'').trim();
    if(!want||!got) return true;
    return got===want;
  }
  function samePlan(line,p){ return !!(line&&p&&line.variant_id===p.v[0]&&line.quantity===p.qty&&sameCountry(line)); }
  // Why the prepaid line went stale, shown where the toggle is. Without it the charge just vanishes
  // and the customer never learns they have to re-confirm at the new amount.
  function setSwitches(on){ document.querySelectorAll('#ls-sw').forEach(function(x){ x.checked=!!on; }); }
  function clearStale(){ lsQuiet(function(){ document.querySelectorAll('.ls-stale').forEach(function(n){ n.remove(); }); }); }
  function staleNote(){
    var b=box(); if(!b) return; var card=b.querySelector('.ls-card'); if(!card) return;
    var n=card.querySelector('.ls-stale');
    if(!n){ n=document.createElement('div'); n.className='ls-stale'; lsQuiet(function(){ card.appendChild(n); }); }
    n.textContent='Your cart changed, so the prepaid duties and taxes no longer match it. The estimate is now '
      +(b.getAttribute('data-amt')||'')+'. Switch it back on to prepay, or continue and pay at customs on delivery.';
    try{ n.scrollIntoView({block:'center',behavior:'smooth'}); }catch(e){}
  }
  // Same trap as box(): the drawer's .cart-items table is first in the DOM and has no section, so on
  // /cart this returned items:null and the item list was never re-rendered after a duty-line change.
  function cartItemsSection(){
    var its=document.querySelectorAll('.cart-items, cart-items');
    for(var i=0;i<its.length;i++){ var sec=its[i].closest('[id^="shopify-section"]'); if(sec) return sec; }
    return null;
  }
  function sectionIds(){
    var b=box(), f=b?b.closest('[id^="shopify-section"]'):null, it=cartItemsSection();
    return { items: it?it.id.replace('shopify-section-',''):null, footer: f?f.id.replace('shopify-section-',''):null };
  }
  function swap(id, html){ if(!id||!html) return; var el=document.getElementById('shopify-section-'+id); if(!el) return;
    var doc=new DOMParser().parseFromString(html,'text/html'); var src=doc.getElementById('shopify-section-'+id);
    lsQuiet(function(){ el.innerHTML = src ? src.innerHTML : html; }); }
  // rebuild the duties cart line into ONE full-width row (name left, amount right)
  function decorate(){ lsQuiet(function(){
    document.querySelectorAll('.cart-item').forEach(function(row){
      if(row.getAttribute('data-ls-done')) return;
      var link=row.querySelector('a[href*="/products/import-duties"]');
      if(link || /Import Duties & Taxes/i.test(row.textContent)){
        /* a DISCOUNTED duty line (prepaid-tax absorption) prices differently in each view: the cart page puts the old
           price in the FIRST .price--end, and the drawer has no .price--end at all. Read the discounted block when it
           is there, and fall back to the old behaviour when the line is not discounted. */
        var oldEl=row.querySelector('.cart-item__old-price'), txt=function(e){ return e?e.textContent.replace(/\s+/g,' ').trim():''; };
        var finEl=oldEl && row.querySelector('.cart-item__discounted-prices .price:not(.cart-item__old-price), .ix-line-price .price:not(.cart-item__old-price)');
        var noteEl=oldEl && row.querySelector('.discounts__discount');
        var p=row.querySelector('.price--end, .ix-cart-price-strip');
        var amt = oldEl ? ('<s class="ls-cl-was">'+txt(oldEl)+'</s> '+txt(finEl)) : txt(p);
        var note = noteEl ? txt(noteEl) : '';
        row.classList.add('ls-duty-line'); row.setAttribute('data-ls-done','1');
        var span=row.children.length||1;
        row.innerHTML='<td class="ls-duty-cell" colspan="'+span+'"><div class="ls-cartline"><span class="ls-cl-name">Import duties &amp; taxes (prepaid)</span><span class="ls-cl-amt">'+amt+'</span></div>'
          +(note?'<div class="ls-cl-note">'+note+'</div>':'')+'</td>';
        if(row.parentNode) row.parentNode.appendChild(row);
      }
    });
  }); }
  // ---- optimistic render: flip the box + duties line INSTANTLY (0 round-trips), reconcile after ----
  function fineTxt(){ return 'Duty rates: '+((box()&&box().getAttribute('data-country'))||'')+' 2026 rules (WITS UNCTAD TRAINS) · powered by LandedSEA'; }
  function applyBoxState(on){
    var b=box(); if(!b) return;
    var title=b.querySelector('.ls-title'), sub=b.querySelector('.ls-sub'), body=b.querySelector('.ls-body');
    if(title) title.textContent = on ? 'Duties & taxes — paid in full (DDP)' : 'Duties & taxes — payable at customs (DDU)';
    if(sub) sub.textContent = on ? 'You pay them now at checkout — nothing to pay FedEx on delivery.' : 'FedEx collects them from you on delivery. Toggle on to prepay now.';
    if(!body) return;
    var amt=b.getAttribute('data-amt')||'', tot=b.getAttribute('data-total')||'';
    if(on){ body.classList.add('open');
      body.innerHTML='<div class="ls-row"><span class="k">Import duties &amp; taxes</span><span>'+amt+'</span></div>'
        +'<div class="ls-row tot"><span>New order total</span><span>'+tot+'</span></div><div class="ls-fine">'+fineTxt()+'</div>';
    } else { body.classList.remove('open');
      body.innerHTML='<div class="ls-teaser">Adds '+amt+' upfront.</div><div class="ls-fine">'+fineTxt()+'</div>'; }
  }
  function optimisticLine(on){ lsQuiet(function(){
    if(!on){ document.querySelectorAll('.ls-duty-line').forEach(function(r){ r.remove(); }); return; }  // off → drop ALL duty rows now
    document.querySelectorAll('.ls-duty-line[data-ls-optimistic]').forEach(function(r){ r.remove(); });
    if(document.querySelector('.ls-duty-line')) return;                 // a real line already shows
    var rows=document.querySelectorAll('.cart-item'); if(!rows.length) return;
    var ref=rows[rows.length-1], span=ref.children.length||1, amt=(box()&&box().getAttribute('data-amt'))||'';
    var tr=document.createElement('tr'); tr.className='cart-item ls-duty-line';
    tr.setAttribute('data-ls-done','1'); tr.setAttribute('data-ls-optimistic','1');
    tr.innerHTML='<td class="ls-duty-cell" colspan="'+span+'"><div class="ls-cartline"><span class="ls-cl-name">Import duties &amp; taxes (prepaid)</span><span class="ls-cl-amt">'+amt+'</span></div></td>';
    ref.parentNode.appendChild(tr);
  }); }
  var busy=false, lastToggleAt=0;
  async function toggle(sw){
    if(busy){ sw.checked=!sw.checked; return; }
    busy=true; lastToggleAt=Date.now();
    var on=sw.checked, d=data(), s=sectionIds(), secs=[s.items,s.footer].filter(Boolean).join(',');
    var dm=!secs && inDrawer();   // drawer: no section ids -> refresh via the theme drawer, never reload
    applyBoxState(on); optimisticLine(on); clearStale();   // <-- INSTANT: no waiting on the server
    try{
      /* 2026-09-24: GET section render + cart read IN PARALLEL. This was a POST /cart/update.js{sections}: a cart write
         that took the cart lock and ~2.2s on a live ID cart, before the add could even start (toggle ON settled at 3.4s). */
      var both=await Promise.all([getSections(DRAWER).catch(function(){ return null; }), getCart()]);
      var fr=both[0], c=both[1];
      if(fr&&fr.sections){ absorb(fr.sections[DRAWER]); d=data(); }   // quantity edits on /cart never refresh the drawer copy
      for(var i=0;i<c.items.length;i++){ if(d.ids[c.items[i].variant_id]) await post(LSU.change,{id:c.items[i].key,quantity:0}); }
      var resp;
      if(on && d.v.length){
        var p=plan(d.v, d.addon);
        var ctry=(box().getAttribute('data-country')||'')+' (DDP)';
        resp=await post(LSU.add,{items:[{id:p.v[0],quantity:p.qty,properties:{'Import duties & taxes':ctry}}],sections:dm?DRAWER_SECS:secs,sections_url:LSU.cart});
      } else {
        resp=await getSections(dm?DRAWER_SECS:secs);             // fresh sections after the removal - GET, no cart lock
      }
      if(dm){
        await refreshDrawer(resp);   // the cart itself is already right; if the re-render fails the optimistic state stays - no reload
        setSwitches(on); lastToggleAt=Date.now(); busy=false; return;
      }
      if(resp && resp.sections){
        swap(s.items, resp.sections[s.items]); swap(s.footer, resp.sections[s.footer]); decorate();
        setSwitches(on);   // authoritative: every copy of the switch reflects the user's choice, not a transitional server render
        lastToggleAt=Date.now(); busy=false;
      }
      else { window.location.reload(); }
    }catch(e){ if(dm){ busy=false; return; } window.location.reload(); }
  }
  /* Adam 2026-09-24: "by default, duties and taxes should be turned on instead of off".
     The switch reflects whether the prepaid-duties product is IN the cart, so defaulting it on means
     really adding that line. Three guards, so this can never fight the customer or spin:
       - it stops for good once the customer switches it OFF (session opt-out, cleared if they switch back on),
       - at most 2 attempts per session, because toggle() reloads the page when the cart call fails and an
         unguarded retry would be a reload loop,
       - it only runs when there IS something to prepay (not under a de-minimis, addon > 0).
     Once the line is in the cart the server renders the switch checked, so this simply stops firing. */
  var LS_OPTOUT='ix-ddp-optout', LS_TRIES='ix-ddp-autotries';
  function ssGet(k){ try{ return sessionStorage.getItem(k); }catch(e){ return null; } }
  function ssSet(k,v){ try{ sessionStorage.setItem(k,v); }catch(e){} }
  function ssDel(k){ try{ sessionStorage.removeItem(k); }catch(e){} }
  var lsAutoWanted=false;
  function noAuto(){ var b=box(); return !!(b && b.getAttribute('data-noauto')==='1'); }   // ID test 2026-10-15: never add the line on our own
  function autoWanted(){
    var b=box(); if(!b || b.getAttribute('data-below')==='true' || noAuto()) return false;
    if(ssGet(LS_OPTOUT)==='1') return false;
    if(parseInt(ssGet(LS_TRIES)||'0',10)>=2) return false;
    var sw=document.getElementById('ls-sw'); if(!sw || sw.checked) return false;
    var d=data(); return !!(d.addon && d.v.length);
  }
  /* Runs at SCRIPT-PARSE time, straight after the markup above, so the switch is never painted in the
     off state it is about to leave. Pure DOM, no network, no cart lock. */
  function paintOn(){
    if(!autoWanted()) return;
    lsAutoWanted=true;
    document.getElementById('ls-sw').checked=true;
    try{ applyBoxState(true); }catch(e){}
  }
  /* The cart write, at DOMContentLoaded. toggle() runs FOUR sequential cart calls (update -> get ->
     change xN -> add) because it must undo whatever state the cart was in. Auto-enable does not: the
     switch was off, so the server rendered no duties line and there is nothing to undo. One /cart/add.js
     is enough, which took the settle time from ~2.9s to well under a second (measured 2026-09-24).
     It also must NEVER reload on failure the way toggle() does - that would be a reload loop. */
  async function autoAdd(){
    if(busy) return; busy=true; lastToggleAt=Date.now();
    var d=data(), s=sectionIds(), secs=[s.items,s.footer].filter(Boolean).join(',');
    applyBoxState(true); optimisticLine(true); clearStale();
    try{
      var p=plan(d.v, d.addon);
      if(!p){ busy=false; return; }
      var ctry=(box().getAttribute('data-country')||'')+' (DDP)';
      var resp=await post(LSU.add,{items:[{id:p.v[0],quantity:p.qty,properties:{'Import duties & taxes':ctry}}],sections:secs,sections_url:LSU.cart});
      if(resp && resp.sections){ swap(s.items, resp.sections[s.items]); swap(s.footer, resp.sections[s.footer]); decorate(); }
      var cP=await getCart();                                   // 2026-10-13: path B on page load - Shopify may have pruned the
      if(!realLines(cP,d).length){                              // unavailable item in this very write; never leave a duties-only cart
        var lnP=dutyLine(cP,d); if(lnP){ try{ await post(LSU.change,{id:lnP.key,quantity:0,sections:withDrawer(secs),sections_url:LSU.cart}).then(function(r2){ if(r2&&r2.sections){ swap(s.items,r2.sections[s.items]); swap(s.footer,r2.sections[s.footer]); if(r2.sections[DRAWER]) absorb(r2.sections[DRAWER]); decorate(); } }); }catch(e){} }
        setSwitches(false); lastToggleAt=Date.now(); busy=false; return;
      }
      setSwitches(true);
    }catch(e){}
    lastToggleAt=Date.now(); busy=false;
  }
  function autoEnable(){
    if(!lsAutoWanted && !autoWanted()) return;
    lsAutoWanted=false;
    ssSet(LS_TRIES,String(parseInt(ssGet(LS_TRIES)||'0',10)+1));
    attachObs(); autoAdd();
  }
  /* EU, Adam 2026-10-02: "by default, the duties toggle should be turned on for EU carts".
     autoEnable() above only runs when a PAGE LOADS with the widget on it. Proved live on a Spain cart: add from a product
     page, open the cart DRAWER, check out - the drawer's widget had the right amount but nothing switched it on, and the
     order went through without the prepaid line (#30763). And when a cart change made the prepaid amount stale, resync()
     switched the toggle OFF and asked the customer to re-confirm.
     For a box rendered with data-auto="1" (EU only from 2 Oct; EVERY market with a prepay toggle since 13 Oct 2026, Adam:
      "duties and toggle should be on by default"; no-fee carts carry data-below="true" so wantLine() still says no) the line is kept ON through both, and at the checkout button,
     unless the customer switched it off themselves (LS_OPTOUT, the same session opt-out as above).
     ensureLine() is ONE /cart/add.js, never a reload, and at most one attempt per cart state (lsAutoSig) so a failed
     add can never loop. `quiet` = no section re-render (the checkout guard: the page is about to leave). */
  function wantLine(){
    var b=box(); if(!b || b.getAttribute('data-auto')!=='1' || b.getAttribute('data-below')==='true') return false;
    if(ssGet(LS_OPTOUT)==='1') return false;
    var d=data(); return !!(d.addon && d.v.length);
  }
  var lsAutoSig=null;
  async function ensureLine(quiet, sig){
    var b=box(), d=data(), p=plan(d.v, d.addon); if(!b || !p) return false;
    sig=(sig||'')+'@'+p.v[0]+'x'+p.qty;
    if(!quiet){ if(sig===lsAutoSig) return false; lsAutoSig=sig; }
    var dr=inDrawer(), s=sectionIds(), secs=quiet ? '' : (dr ? DRAWER_SECS : [s.items,s.footer].filter(Boolean).join(','));
    var body={items:[{id:p.v[0],quantity:p.qty,properties:{'Import duties & taxes':(b.getAttribute('data-country')||'')+' (DDP)'}}]};
    if(secs){ body.sections=secs; body.sections_url=LSU.cart; }
    lastToggleAt=Date.now();
    var resp=await post(LSU.add, body);
    if(!resp || resp.status){ lastToggleAt=Date.now(); return false; }           // 422 / cart lock: leave everything as it is
    var cA=await getCart();                                                       // 2026-10-13: path B - Shopify may have pruned an
    if(!realLines(cA,d).length){                                                  // unavailable item in this very write -> never leave
      var ln=dutyLine(cA,d); if(ln){ try{ await post(LSU.change,{id:ln.key,quantity:0}); }catch(e){} }   // a duties-only cart
      lastToggleAt=Date.now(); setSwitches(false); return false;
    }
    if(!quiet){
      if(dr){ await refreshDrawer(resp); }
      else if(resp.sections){ swap(s.items, resp.sections[s.items]); swap(s.footer, resp.sections[s.footer]); decorate(); }
    }
    clearStale(); setSwitches(true);
    try{ if(!dr || quiet) applyBoxState(true); }catch(e){}
    lastToggleAt=Date.now(); return true;
  }
  // delegated change (survives cart section re-renders, mine or the theme's)
  document.addEventListener('change', function(e){ if(e.target && e.target.id==='ls-sw'){
    if(e.target.checked){ ssDel(LS_OPTOUT); } else { ssSet(LS_OPTOUT,'1'); }   // remember an explicit opt-out
    attachObs(); toggle(e.target); } });
  /* 2026-10-13 (abandoned checkout 36542414848046, Indonesia): a duties-only cart reached checkout. Two paths, reproduced by the
     conversion session: (A) the last real item removed in the drawer and Checkout pressed inside the 1-6 s before resync's orphan
     drop; (B) Shopify pruning an item that went unavailable in the SAME /cart/add.js that adds the duty line (our own write, so
     no resync follows). realLines() is the one definition of "a real item"; dropIfOrphan() runs at page load and after our own
     add; the checkout guard refuses to proceed when nothing real is left. Server-side backstop: the Block Duties-Only Checkout
     validation function (inlinex-admin-61). */
  function realLines(c,d){ var ids=(d&&d.ids)||{}; return (c&&c.items||[]).filter(function(i){ return i.handle!=='import-duties-taxes-prepaid' && !ids[i.variant_id] && i.requires_shipping!==false; }); }
  function dutyLine(c,d){ var ids=(d&&d.ids)||{}; return (c&&c.items||[]).filter(function(i){ return ids[i.variant_id] || i.handle==='import-duties-taxes-prepaid'; })[0]; }
  function dropIfOrphan(){
    return getCart().then(function(c){
      var d=data(), line=dutyLine(c,d); if(!line || realLines(c,d).length) return false;
      var s=sectionIds(), secs=withDrawer([s.items,s.footer].filter(Boolean).join(','));
      return post(LSU.change,{id:line.key,quantity:0,sections:secs,sections_url:LSU.cart}).then(function(resp){
        if(resp&&resp.sections){ swap(s.items,resp.sections[s.items]); swap(s.footer,resp.sections[s.footer]); if(resp.sections[DRAWER]) absorb(resp.sections[DRAWER]); decorate(); }
        setSwitches(false); return true;
      });
    }).catch(function(){ return false; });
  }
  function removeOrphan(){
    var s=sectionIds(), secs=[s.items,s.footer].filter(Boolean).join(',');
    getCart().then(function(c){
      var line=(c.items||[]).filter(function(i){ return i.handle==='import-duties-taxes-prepaid'; })[0];
      if(!line) return;
      post(LSU.change,{id:line.key,quantity:0,sections:secs,sections_url:LSU.cart}).then(function(resp){
        if(resp&&resp.sections){ swap(s.items,resp.sections[s.items]); swap(s.footer,resp.sections[s.footer]); decorate(); }
        else window.location.reload();
      }).catch(function(){});
    }).catch(function(){});
  }
  // Re-sync when the cart changes via the THEME (qty steppers, item removal). Our box lives
  // OUTSIDE .js-contents, so the theme's partial section re-render (which only swaps the
  // subtotal) NEVER refreshes it — leaving the below/above decision, addon + toggle stale.
  // Fix: re-render the footer section from the server (fresh below/above/addon/toggle) and
  // reconcile the duties line so it always matches the current cart.
  var syncing=false, dirty=false, syncT=null;
  function scheduleSync(){ clearTimeout(syncT); syncT=setTimeout(runSync, 120); }
  function runSync(){ if(!box()) return;   // no widget = market without prepay (US, SG) or empty cart: nothing to reconcile, no request
    if(busy||syncing){ dirty=true; return; }
    if(Date.now()-lastToggleAt < 900){ scheduleSync(); return; }   // a toggle just set the authoritative state — let it settle before a resync re-swaps (was the on/off "bounce")
    resync(); }
  async function resync(){
    syncing=true; dirty=false;
    try{
      var s=sectionIds(), secs=[s.items,s.footer].filter(Boolean).join(',');
      var resp=await getSections(withDrawer(secs));   // no cart change, just fresh sections (GET, no cart lock)
      if(resp&&resp.sections){ swap(s.footer, resp.sections[s.footer]); decorate(); absorb(resp.sections[DRAWER]); }
      attachObs();   // cart was empty at load → the observer never bound; it can now
      var b=box();
      if(b){
        var d=data(), below=b.getAttribute('data-below')==='true';
        var c=await getCart();
        var line=(c.items||[]).filter(function(i){ return d.ids[i.variant_id] || i.handle==='import-duties-taxes-prepaid'; })[0];
        var changed=false, told=false, lineHad=!!line;   // ID test: a line the shopper switched on is kept (replaced when stale), never added by us
        // Nothing left but add-ons: the customer removed their last real product, so the prepaid-duties
        // line is orphaned whatever the market rules say. Drop it rather than leave a duties-only cart
        // (which checkout blocks anyway). Runs before the de-minimis branch so it can never be skipped.
        var real=(c.items||[]).filter(function(i){ return i.handle!=='import-duties-taxes-prepaid' && !d.ids[i.variant_id] && i.requires_shipping!==false; });
        if(line && !real.length){
          await post(LSU.change,{id:line.key,quantity:0}); changed=true; line=null;
        } else if(below && line){                            // dropped under de-minimis → nothing to prepay
          await post(LSU.change,{id:line.key,quantity:0}); changed=true;
        } else if(!below && line && d.v.length){             // DDP on, but cart changed → prepaid amount is now stale
          if(!samePlan(line, plan(d.v, d.addon))){           // amount no longer matches: revert to OFF so the customer
            await post(LSU.change,{id:line.key,quantity:0});  // re-confirms. REMOVE-ONLY (never add) → no race with
            changed=true; told=true; line=null;              // the theme's own in-flight cart update (Shopify 422 lock).
          }
        }
        var lsKeep=!!(real.length && (wantLine() || (noAuto() && lineHad)));            // EU default-on (data-auto): the line stays ON, see ensureLine(); ID test: only if the shopper had one
        if(changed){
          var r2=await getSections(secs);
          if(r2&&r2.sections){ swap(s.items, r2.sections[s.items]); swap(s.footer, r2.sections[s.footer]); decorate(); }
          if(told && !lsKeep){ setSwitches(false); staleNote(); }
        }
        if(lsKeep && !line){                                 // no prepaid line (never added, or the stale one just removed)
          var lsSig=real.map(function(i){ return i.key+':'+i.quantity; }).join('|');
          try{ var lsOk=await ensureLine(false, lsSig); if(!lsOk && told){ setSwitches(false); staleNote(); } }catch(e){}
        }
      }
    }catch(e){}
    syncing=false;
    if(dirty){ dirty=false; scheduleSync(); }   // a cart change arrived mid-sync → run once more so nothing is stale
  }
  // Attach the cart-watching observer. Guarded on the widget actually being present, so on an
  // empty-cart page (script loads, markup does not) this is a no-op and we never observe document.body.
  var booted=false;
  function attachObs(){
    if(booted || !box()) return;
    booted=true;
    var it=document.querySelector('.cart-items, cart-items');
    var target=cartItemsSection()||it||document.body;   // stable wrapper: survives cart-items re-render; on /cart watch the page's list, not the drawer's
    if(target){ lsTarget=target; lsObs=new MutationObserver(function(muts){
      // Ignore the pre-order countdown's per-second timer tick: it replaces .ixpu-timer's text
      // (a childList mutation) every second, which would otherwise fire a resync every second
      // → footer churn + the pre-order badge reverting to its server message then re-skinning.
      for(var i=0;i<muts.length;i++){
        var t=muts[i].target, el=(t&&t.nodeType===3)?t.parentElement:t;
        if(el&&el.closest&&el.closest('.ixpu-timer')) continue;   // countdown tick — not a real cart change
        decorate(); scheduleSync(); return;                       // a genuine cart change (qty, item removal)
      }
    }); lsObsOn(); } }
  // ---- guard 1: every cart write, from anywhere, triggers a resync ----
  // The observer only sees cart changes that repaint a cart DOM it is already watching, and it binds
  // only if the widget was on the page at load. The path that cost money slips past both: switch
  // prepay on with a small cart, add more from a product page or quick-add, check out from the drawer.
  // The line kept its old amount. #29351 (India) collected S$43.35 on a S$1,034 cart - the figure for
  // the one S$140 item that was in the basket when the switch was flipped. FedEx billed S$115.91.
  // Hooking fetch catches every theme cart write regardless of which DOM it repaints.
  var verified=false, verifying=false;
  /* guard 1 wrapper itself is inline in the snippet (keeps the fetch chain order); it calls these: */
  window.__lsHook={invalidate:function(){ verified=false; }, after:function(){ scheduleSync(); }};
  if(window.__lsPend){ window.__lsPend=0; verified=false; scheduleSync(); }
  // ---- guard 2: re-check at the checkout button ----
  // Last line of defence for a checkout clicked inside the resync debounce. Pull a fresh render,
  // and if the prepaid line no longer matches the cart, drop it (same remove-only rule) and explain.
  // On any error, let the customer through: losing this check once beats blocking a sale.
  async function verifyDuties(){
    var s=sectionIds(), secs=[s.items,s.footer].filter(Boolean).join(',');
    // numbers only: re-rendering the footer here would REPLACE the checkout button that was just
    // clicked, and the follow-up click would land on a detached element and do nothing
    var resp=await post(LSU.update,{sections:DRAWER,sections_url:LSU.cart});
    if(resp&&resp.sections) absorb(resp.sections[DRAWER]);
    var b=box(); if(!b) return true;
    var d=data(), below=b.getAttribute('data-below')==='true';
    var c=await getCart();
    var line=dutyLine(c,d);
    if(!realLines(c,d).length){                                       // 2026-10-13: nothing real left (path A) - never check out duties-only
      if(line){ try{ await post(LSU.change,{id:line.key,quantity:0}); }catch(e){} }
      var r0=await post(LSU.update,{sections:withDrawer(secs),sections_url:LSU.cart});
      if(r0&&r0.sections){ swap(s.items,r0.sections[s.items]); swap(s.footer,r0.sections[s.footer]); if(r0.sections[DRAWER]) absorb(r0.sections[DRAWER]); decorate(); }
      setSwitches(false); return false;
    }
    if(!line){                                                        // nothing prepaid: ships DDU ...
      if(wantLine()){ try{ var added=await ensureLine(true); if(added===false){ var cB=await getCart(); if(!realLines(cB,d).length) return false; } }catch(e){} }   // default-on cart that never opted out; a pruned cart stays put
      return true;
    }
    if(!below && samePlan(line, plan(d.v, d.addon))) return true;    // amount still right
    await post(LSU.change,{id:line.key,quantity:0});
    if(!below && (wantLine() || noAuto())){ try{ if(await ensureLine(true)) return true; }catch(e){} }   // EU: replace the stale amount and carry on; ID test: the shopper's own line is replaced, not dropped
    var r2=await post(LSU.update,{sections:secs,sections_url:LSU.cart});
    if(r2&&r2.sections){ swap(s.items,r2.sections[s.items]); swap(s.footer,r2.sections[s.footer]); decorate(); }
    setSwitches(false);
    if(!below) staleNote();
    return below;                                                      // under de-minimis: nothing to prepay, proceed
  }
  document.addEventListener('click', function(e){
    var btn=(e.target&&e.target.closest)?e.target.closest('#checkout, #CartDrawer-Checkout, .cart__checkout-button, button[name="checkout"]'):null;
    if(!btn||verified||!box()) return;
    e.preventDefault(); e.stopPropagation();
    if(verifying) return;
    verifying=true;
    // any re-render since the click may have replaced the button: click the one on the page now
    function go(){ verified=true; var now=(btn.id&&document.getElementById(btn.id))||(btn.isConnected?btn:document.querySelector('#checkout, #CartDrawer-Checkout')); if(now) now.click(); }
    verifyDuties().then(function(ok){ verifying=false; if(ok) go(); }, function(){ verifying=false; go(); });
  }, true);
  function ready(){ decorate();
    dropIfOrphan().then(function(dropped){                              // 2026-10-13: an orphaned duty line is dropped on EVERY page load
      var b=box(); if(!dropped && b && b.getAttribute('data-below')==='true'){ removeOrphan(); }   // under de-minimis: nothing to prepay
      attachObs(); if(!dropped) autoEnable();                             // never re-add into a cart that just lost its last real item
    }); }
  try{ paintOn(); }catch(e){}   // before first paint: never show the switch off when it is about to be on
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
